import {
  IconLayoutGrid,
  IconStack2,
  IconPuzzle,
  IconCircleCheckFilled,
  IconBuildingBank,
} from '@tabler/icons-react';
import { ReactNode } from 'react';
import Home from '../../pages/Home';
import Builder from '../../pages/builder';
import StakerIndex from '../../pages/staker';
import Contribution from '../../pages/contribution';
import Virtual from '../../pages/virtual';
import Login from '../../pages/login';
import Validator from '../../pages/validator';
import Withdraw from '../../pages/staker/withdraw/index';
import PrivacyPolicy from '../../pages/docs/PrivacyPolicy';
import TermsCondition from '../../pages/docs/TermsCondition';
import { AiFillCode } from 'react-icons/ai';

export interface Route {
  title: string;
  path: string;
  icon: ReactNode;
  element: ReactNode;
  auth?: boolean;
  index?: boolean;
  hasVirtualOnVotingPhase?: Boolean;
}

type RouteKeys = 'HOME' | 'LOGIN' | 'WITHDRAW' | 'GOVERNANCE';
// | 'STAKER'
// | 'VIRTUAL'
// | 'VALIDATOR'
// | 'CONTRIBUTION'
// | 'BUILDER';
// | 'BUY_TOKEN'
// | 'DASHBOARD';

type RouteConstants = {
  [key in RouteKeys]: Route;
};

const governanceUrl =
  process.env.REACT_APP_ENVIRONMENT === 'development'
    ? 'https://gov-dev.virtuals.io/'
    : 'https://gov.virtuals.io/';

const routeConstants: RouteConstants = Object.freeze({
  HOME: {
    title: 'Home',
    path: '/',
    icon: <IconLayoutGrid size={20} />,
    element: <Home />,
    index: true,
  },
  WITHDRAW: {
    title: 'Withdraw',
    path: '/stake/withdraw',
    icon: <IconStack2 size={20} />,
    // auth: true,
    element: <Withdraw />,
  },
  LOGIN: {
    title: 'Login',
    path: '/login',
    icon: <IconPuzzle size={20} />,
    element: <Login />,
  },
  PRIVACY: {
    title: 'Privacy',
    path: '/privacy-policy',
    icon: <IconPuzzle size={20} />,
    element: <PrivacyPolicy />,
  },
  TERMS: {
    title: 'Terms',
    path: '/terms-condition',
    icon: <IconPuzzle size={20} />,
    element: <TermsCondition />,
  },
  GOVERNANCE: {
    title: 'Governance Forum',
    path: governanceUrl,
    icon: <IconBuildingBank size={20} />,
    element: <></>,
  },
  // STAKER: {
  //   title: 'Stake',
  //   path: '/stake',
  //   icon: <IconStack2 size={20} />,
  //   // auth: true,
  //   element: <StakerIndex />,
  // },
  // CONTRIBUTION: {
  //   title: 'Contribute',
  //   path: '/contribution',
  //   icon: <IconPuzzle size={20} />,
  //   // auth: true,
  //   element: <Contribution />,
  // },
  // VALIDATOR: {
  //   title: 'Validate',
  //   path: '/validate',
  //   icon: <IconCircleCheckFilled size={20} />,
  //   // auth: true,
  //   element: <Validator />,
  // },
  // VIRTUAL: {
  //   title: 'Virtual',
  //   path: '/virtual/:id',
  //   icon: <IconPuzzle size={20} />,
  //   // auth: true,
  //   element: <Virtual />,
  // },
  // BUILDER: {
  //   title: 'Builder',
  //   path: '/builder',
  //   icon: <AiFillCode size={20} />,
  //   // auth: true,
  //   element: <Builder />,
  // },
  // DASHBOARD: {
  //   title: 'Dashboard',
  //   path: '/dashboard',
  //   icon: <IconLayoutGrid size={20} />,
  // },
  // BUY_TOKEN: {
  //   title: 'Buy Token',
  //   path: '/buy-token',
  //   icon: <IconCoin size={20} />,
  // },
});

export default routeConstants;
